<template>
	<layout-gestao>
		<PrintVisibleProperties
			:internalCode="moduleCode"
			:title="titleConfigItem"
			name="print-visible-properties"/>
	</layout-gestao>
</template>

<script>
import GeneralMixin from '../../mixin'

export default {
	components: {
		'PrintVisibleProperties': () => import(/* webpackChunkName: "print-visible-properties" */ '@/app/shared/components/manage/print/ManagePrintVisibleProperties'),
	},
	mixins: [
		GeneralMixin,
	],
}
</script>
